import { apiGet, apiPatch, apiPost } from '../../../apiClient';

export const login = (payload) => apiPost('/auth/login', payload);

export const renewPassword = (token, payload) =>
  apiPost('/auth/renew-password', payload, token);

export const logout = (token) => apiPost('/auth/logout', null, token);

export const getMe = (token) => apiGet('/auth/me', token);

export const getMyBranches = (token) => apiGet('/auth/me/branches', token);

export const setActiveBranch = (token, branchId) =>
  apiPatch('/auth/me/active-branch', { branch_id: branchId }, token);

export const setActiveCounter = (token, counterId) =>
  apiPatch('/auth/me/active-counter', { counter_id: counterId }, token);
